define('views/content/distributor_settings',['require','backbone','views/components/distributor_settings/company_settings','views/components/distributor_settings/profile_settings','views/components/distributor_settings/password_settings','models/distributor','models/distributor_manager','text!templates/content/distributor_settings.html'],function(require){

    var Backbone = require('backbone');

    var CompanySettingsView = require('views/components/distributor_settings/company_settings');
    var ProfileSettingsView = require('views/components/distributor_settings/profile_settings');
    var PasswordSettingsView = require('views/components/distributor_settings/password_settings');

    var DistributorModel = require('models/distributor');
    var DistributorManagerModel = require('models/distributor_manager');

    var temp = require("text!templates/content/distributor_settings.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'settings-page page',
        titleKey: 'settings',

        initialize: function () {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        regions: function() {
            return {
                CompanySettingsContainer: ".company-settings",
                ProfileSettingsContainer: ".profile-settings",
                PasswordSettingsContainer: ".password-settings"
            };
        },

        onRender: function () {
            var _this = this;

            var distributor = new DistributorModel({
                id: App.user.get('distributor')
            });

            distributor.fetch({
                success: function () {
                    _this.CompanySettingsContainer.show(new CompanySettingsView({
                        model: distributor
                    }));
                }
            });

            var manager = new DistributorManagerModel({
                id: App.user.get('id')
            });

            manager.fetch({
                success: function () {
                    _this.ProfileSettingsContainer.show(new ProfileSettingsView({
                        model: manager
                    }));
                }
            });

            _this.PasswordSettingsContainer.show(new PasswordSettingsView());
        }
    });
});
